<script lang="ts" setup>
import { ref, toRefs } from 'vue';
import { InputNumberInputEvent } from 'primevue/inputnumber';
import { useProgressReportDropdown } from '@/composables';
import ProgressReportOptions from '@/assets/json/progress_options.json';

interface Props {
  goalId: undefined | number;
}

const props = withDefaults(defineProps<Props>(), { goalId: undefined });

const { goalId } = toRefs(props);

const intensityType = ref();

const onChange = (event: InputNumberInputEvent) => useProgressReportDropdown(goalId, 'intensity_type').onChange(event);
</script>

<template>
  <div>
    <Dropdown
      v-model="intensityType"
      :options="ProgressReportOptions.intensity_types"
      option-label="name"
      option-value="value"
      placeholder="Select Intensity Type"
      @change="onChange"
    />
  </div>
</template>
